<div class="outercontainer">
  <div class="innercontainer">
    <ng-content></ng-content>
  </div>
</div>
